import { render } from "./phone-number-input.component..vue?vue&type=template&id=20d9af6b&ts=true"
import script from "./phone-number-input.component..vue?vue&type=script&lang=ts"
export * from "./phone-number-input.component..vue?vue&type=script&lang=ts"

import "./phone-number-input.component..vue?vue&type=style&index=0&id=20d9af6b&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__